
import { cloud_mqttSender } from "@/api/anycubic_axios";



class ClouddMqtt {
    constructor(identity) {
        this.identity = identity;
        // mqtt是否连接成功
        this.connected = false;
    }
    get_identity() {
        return this.identity;
    }
    destroy() {
    }
    connect(mode, host, port, device_type, username, password, clientid, Certificate, PrivateKey, KeyStore) {
        let response = -1
        cloud_mqttSender.put("connect", { "device_type": device_type })
            .then((res) => response = res)
        return response;
    }
    async subscribe(topic) {
        if (!this.connected) return -1
        let response = -1
        response = await cloud_mqttSender.post("subscribe", { "topic": topic })
        return response;
    }
    subscribe_printer(model_id, device) {
        if (!this.connected) return -1
        let response = -1
        cloud_mqttSender.delete("subscribe_printer", { "model_id": model_id, "device": device })
            .then((res) => response = res)
        return response;
    }
    unsubscribe(topic) {
        if (!this.connected) return -1
        let response = -1
        cloud_mqttSender.delete("unsubscribe", { "topic": topic })
            .then((res) => response = res)
        return response;
    }
    publish(topic, payload) {
        if (!this.connected) return -1
        let response = -1
        cloud_mqttSender.post("publish", { "topic": topic, 'payload': payload })
            .then((res) => response = res)
        return response;
    }
    disconnect() {
        if (!this.connected) return -1
        let response = -1
        cloud_mqttSender.put("disconnect", {})
            .then((res) => response = res)
        return response;
    }
    async is_connected() {
        // 0成功 1失败
        let { data } = await cloud_mqttSender.get("connected", null)
        this.connected = data
        return data
    }
    async event_call(callback) {
        window.cloud_mqtt_event_func = (action, code, msg) => {
            console.log(action, code, msg, "==================》cloud_mqtt event");
            if (action == 1) {
                that.connected = code == 0;
            }
            callback(action, code, msg)
        };
        let response = -1
        response = await cloud_mqttSender.post("event_call", { "script": "window.cloud_mqtt_event_func" })
        return response;

    }
    async set_recv(callback) {
        window.cloud_mqtt_data_func = (topic, payload) => {
            console.log(topic, payload, "=======================================================》cloud_mqtt data");
            callback(topic, payload)
        };
        let { data } = await cloud_mqttSender.post("data_call", { "script": "window.cloud_mqtt_data_func" })
        // 0成功 1失败
        return !data;
    }
}

export async function createCloudMqtt(identity, objectName, mode) {
    return new ClouddMqtt(identity);
}